import { c as _c } from "react/compiler-runtime";
import { NewspaperIcon, QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import { LeafIcon } from "@shared/ui/custom-icon";
import React from "react";
import { SearchCategory } from "../types";
export function SearchCategoryIcon(t0) {
  const $ = _c(10);
  const {
    category,
    size: t1
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const t2 = size === "md" ? "size-5 min-w-5" : "size-6 min-w-6";
  let t3;
  if ($[0] !== t2) {
    t3 = <QuestionMarkCircleIcon className={t2} />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = size === "md" ? "size-5 min-w-5" : "size-6 min-w-6";
  let t5;
  if ($[2] !== t4) {
    t5 = <NewspaperIcon className={t4} />;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = size === "md" ? "size-5 min-w-5" : "size-6 min-w-6";
  let t7;
  if ($[4] !== t6) {
    t7 = <LeafIcon className={t6} />;
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== t3 || $[7] !== t5 || $[8] !== t7) {
    t8 = {
      faq: t3,
      article: t5,
      product: t7
    };
    $[6] = t3;
    $[7] = t5;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const mapping = t8;
  return mapping[category];
}